<template>
  <hic-index-page title="科室管理" hide-footer>
    <template slot="buttons">
      <el-button type="primary" @click="create()" size="small" v-if="permission.masterdata_dept_create">
        <i class="el-icon-plus"></i>
        新建
      </el-button>
    </template>

    <template slot="search">
      <el-input v-model="condition.keyword" placeholder="请输入名称或编码" size="small" v-on:keyup.enter.native="page" class="condition-wide left-pad" clearable @clear="page">
        <el-button :loading="searchLoading" slot="append" icon="el-icon-search" @click="page"></el-button>
      </el-input>
    </template>

    <el-table :data="entities.items" :tree-props="{ children: 'children' }" row-key="id" height="100%" default-expand-all class="main-table" v-loading="searchLoading">
      <el-table-column label="名称" prop="name" min-width="200" fixed="left">
        <template slot-scope="{ row }">
          <b>{{ row.name }}</b>
        </template>
      </el-table-column>
      <el-table-column v-if="permission.masterdata_dept_edit || permission.masterdata_dept_delete" label="操作" width="150" align="center" fixed="left">
        <template slot-scope="scope">
          <el-button v-if="permission.masterdata_dept_edit && scope.row.id" type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row)" />
          <hic-regret-button v-if="permission.masterdata_dept_delete && scope.row.id" type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
          <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
          <el-button v-if="permission.masterdata_dept_create && scope.row.id" type="success" icon="el-icon-plus" circle plain size="mini" class="left-pad" @click="create(scope.row)" />
        </template>
      </el-table-column>

      <el-table-column label="编码" prop="code" min-width="50" align="center"></el-table-column>

      <el-table-column label="科室类别" prop="deptType" align="center" :filters="dictEnum.DeptType" :filter-multiple="false" :filter-method="filterChanged" width="120" column-key="deptType">
        <template slot-scope="scope">
          <el-tag type="primary" size="mini" effect="plain">{{ scope.row.deptType }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="门诊" prop="ifOp" align="center" width="60" :filters="ifOptions" :filter-multiple="false" column-key="ifOp" :filter-method="filterChanged">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifOp" type="success" size="mini" effect="plain">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="住院" prop="ifIp" align="center" width="60" :filters="ifOptions" :filter-multiple="false" column-key="ifIp" :filter-method="filterChanged">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifIp" type="success" size="mini" effect="plain">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="急诊" prop="ifEmrg" align="center" width="60" :filters="ifOptions" :filter-multiple="false" column-key="ifEmrg" :filter-method="filterChanged">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifEmrg" type="success" size="mini" effect="plain">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="执行" prop="ifExeDept" align="center" width="60" :filters="ifOptions" :filter-multiple="false" column-key="ifExeDept" :filter-method="filterChanged">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifExeDept" type="success" size="mini" effect="plain">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="检验" prop="ifExamine" align="center" width="60" :filters="ifOptions" :filter-multiple="false" column-key="ifExeDept" :filter-method="filterChanged">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifExamine" type="success" size="mini" effect="plain">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="检查" prop="ifCheck" align="center" width="60" :filters="ifOptions" :filter-multiple="false" column-key="ifExeDept" :filter-method="filterChanged">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifCheck" type="success" size="mini" effect="plain">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="治疗" prop="ifTreat" align="center" width="60" :filters="ifOptions" :filter-multiple="false" column-key="ifExeDept" :filter-method="filterChanged">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifTreat" type="success" size="mini" effect="plain">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="seqNo" width="50" align="right"></el-table-column>
      <el-table-column label="医保科室分类" show-overflow-tooltip align="center" width="120">
        <template slot-scope="scope">
          {{ scope.row.standardDeptCode | dictText("DeptStandard") }}
        </template>
      </el-table-column>
    </el-table>

    <dept-editor v-if="showEditor" v-model="entity" :visible.sync="showEditor" :allDepts="allDepts" @ok="page" />
  </hic-index-page>
</template>

<script>
  import api from "./api.js";
  import store from "@/common/store";
  // import cfg from "@/common/cfg"
  import { mapGetters } from "sw-hic";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.masterdata_dept_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    components: {
      "dept-editor": () => import("./editor"),
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
          return callback(new Error("编码只能包含：【大小写字母】【数字】【_】【-】"));
        }
        return callback();
      };
      return {
        searchLoading: false,
        showEditor: false,
        entities: {},
        entity: {},
        condition: {
          keyword: null,
          sort: "parentCode, seqNo",
          asc: true,
          pageIndexOnView: 1,
        },
        meta: {
          loading: false,
        },
        ifOptions: [
          { text: "是", value: true },
          { text: "否", value: false },
        ],
        allDepts: [],
      };
    },
    computed: {
      ...mapGetters(["dict", "permission", "Enum", "dictEnum"]),
    },
    created: function () {
      this.$store.dispatch("loadDicts", ["Gender", "DeptStandard"]);
      this.page();
    },
    methods: {
      page: function () {
        let _this = this;
        this.meta.loading = true;
        api.Dept.query(this.condition).then((res) => {
          _this.allDepts = JSON.parse(JSON.stringify(res.items));
          for (const dept of res.items) {
            if (dept.parentCode) {
              let find = false;
              for (const parent of res.items) {
                if (parent.code === dept.parentCode) {
                  find = true;
                  if (!parent.children) {
                    parent.children = [];
                  }
                  parent.children.push(dept);
                  break;
                }
              }
            }
          }

          for (let i = res.items.length - 1; i >= 0; i--) {
            if (res.items[i].parentCode) {
              res.items.splice(i, 1);
            }
          }
          _this.entities = res;
          _this.meta.loading = false;
        });
      },
      create: function (parent) {
        this.entity = {
          id: null,
          codeChain: "@",
          parentCode: null,
          seqNo: 1,
          ifOp: false,
          ifIp: false,
          ifEmrg: false,
          ifExeDept: false,
        };
        if (parent) {
          this.entity.parentCode = parent.code;
          this.entity.codeChain = parent.codeChain + parent.code + "@";
          this.entity.parentName = parent.name;
          this.entity.deptType = parent.deptType;
          this.entity.standardDeptCode = parent.standardDeptCode;
        }
        this.showEditor = true;
      },
      edit(row) {
        this.entity = JSON.parse(JSON.stringify(row));
        this.$utils.log(this.entity);
        this.showEditor = true;
      },
      del(row, index) {
        let _this = this;
        api.Dept.del(row.id).then((res) => {
          _this.entities.items.splice(index, 1, {});
          _this.$message.success("删除成功！");
          _this.page();
        });
      },
      filterChanged(value, row, column) {
        const property = column["property"];
        return row[property] === value;
      },
    },
  };
</script>

<style scoped></style>
